<template>
  <ul ref="sidebar" class="sidenav app-sidenav" :class="{open: value}">
    <router-link
      v-for="link in links"
      :key="link.url"
      tag="li"
      active-class="active"
      :to="link.url"
      :exact="link.exact"
    >
      <a @click="close" href="#" class="waves-effect waves-indigo pointer links">{{link.title}}</a>
    </router-link>
  </ul>
</template>

<style>
@media screen and (max-width: 830px) {
  .sidenav {
    width: 65% !important;
  }
}

.links {
  font-size: 18px !important;
}

.waves-effect.waves-indigo .waves-ripple {
  background-color: rgba(92, 107, 192) !important;
}
</style>

<script>
import localizeFilter from "@/filters/localize.filter";

export default {
  props: ["value"],
  data: () => ({
    links: [
      { title: localizeFilter("Menu_Bill"), url: "/", exact: true },
      { title: localizeFilter("Menu_History"), url: "/history" },
      { title: localizeFilter("Menu_Planning"), url: "/planning" },
      { title: localizeFilter("Menu_NewRecord"), url: "/record" },
      { title: localizeFilter("Menu_Categories"), url: "/categories" }
    ],
    width: null
  }),
  watch: {
    width() {
      if (this.width <= 830) {
        this.value = false;
      } else if (this.width > 830) {
        this.value = true;
      }
    }
  },
  methods: {
    updateWidth() {
      this.width = window.innerWidth;
    },
    close() {
      this.$emit("close");
    },
  },
  created() {
    window.addEventListener("resize", this.updateWidth);
  },
};
</script>
